import { Navigate } from "react-router-dom";
import { useCurrentUserQuery } from "src/store/user";

export type UserRole = "tabulator" | "solicitor" | "claimsAdministrator";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

export function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { data: currentUser, isLoading } = useCurrentUserQuery();

  if (isLoading) {
    return null;
  }

  const isTabulator =
    currentUser?.tabulators && currentUser.tabulators.length > 0;
  const isSolicitor =
    currentUser?.solicitors && currentUser.solicitors.length > 0;
  const isClaimsAdministrator =
    currentUser?.claimsAdministrators &&
    currentUser.claimsAdministrators.length > 0;

  const hasAccess = allowedRoles.some((role) => {
    switch (role) {
      case "tabulator":
        return isTabulator;
      case "solicitor":
        return isSolicitor;
      case "claimsAdministrator":
        return isClaimsAdministrator;
      default:
        return false;
    }
  });

  if (!hasAccess) {
    return <Navigate to="/not-found" replace />;
  }

  return <>{children}</>;
}
